import { NoData } from '@finbeat/react-toolkit';
import { getClientSelfie } from 'axios/merchantApi';
import useApi from 'hooks/useApi';
import { MouseEventHandler, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdImageNotSupported } from 'react-icons/md';
import { useQuery } from 'react-query';
import { Col } from 'reactstrap';

const MerchantOrderClientSelfie = ({ selfieFileId }: { selfieFileId: number | null }) => {
    const api = useApi();
    const { t } = useTranslation();

    const ref = useRef<HTMLImageElement>(null);

    const className = 'client-selfie';

    const [igmSrc, setImgSrc] = useState<Blob>();

    const clientFileQuery = useQuery(
        ['orderClientSelfie', selfieFileId],
        () => (selfieFileId ? getClientSelfie(api, selfieFileId) : new Blob()),
        {
            onSuccess: (data) => {
                setImgSrc(data);
            },
            enabled: !!selfieFileId && !igmSrc,
        }
    );

    const src = useMemo(
        () => (igmSrc ? URL.createObjectURL(new Blob([igmSrc], { type: 'image/jpeg' })) : ''),
        [igmSrc]
    );

    const [isBackgroundImageActive, setBackgroundImageActive] = useState(false);

    const [backgroundPosition, setBackgroundPosition] = useState('0% 0%');

    const handleMouseMove: MouseEventHandler<HTMLDivElement> = (e) => {
        const { left, top, width, height } = (e.target as HTMLDivElement).getBoundingClientRect();
        const vars = {
            dividendX: e.pageX - left,
            dividendY: e.pageY - top,
            dividerX: width,
            dividerY: height,
        };

        const x = (vars.dividendX / vars.dividerX) * 100;
        const y = (vars.dividendY / vars.dividerY) * 100;

        setBackgroundPosition(`${x}% ${y}%`);
    };

    return (
        <Col xs="7" className={className}>
            {selfieFileId && (
                <>
                    {clientFileQuery.isFetching && (
                        <div className={`loading ${className}__loading`}></div>
                    )}
                    {!clientFileQuery.isFetching && !src && (
                        <div className={`${className}__img_not-found`}>
                            <MdImageNotSupported />
                        </div>
                    )}
                    {!clientFileQuery.isFetching && src && (
                        <div
                            className={`${className}__img-container`}
                            onMouseMove={handleMouseMove}
                            onMouseEnter={() => setBackgroundImageActive(true)}
                            onMouseLeave={() => setBackgroundImageActive(false)}
                            style={{
                                backgroundPosition: backgroundPosition,
                                backgroundImage: isBackgroundImageActive ? `url(${src})` : 'none',
                            }}
                        >
                            <img
                                ref={ref}
                                alt={t('BackOfficeLogoNotFound')}
                                width="100%"
                                height="100%"
                                className={`${className}__img card-img`}
                                src={src}
                            />
                        </div>
                    )}
                </>
            )}
            {!selfieFileId && <NoData />}
        </Col>
    );
};

export default MerchantOrderClientSelfie;
